export const historyCs = {
  backToMap: 'Zpět na živou mapu',
  historicalData: 'Historická data vozidla',
  vehicleWithoutRegistration: 'Vozidlo poskytovatele',
  providerIdentity: 'ID poskytovatele {id}',
  activeNow: 'Právě v provozu',
  inactiveNow: 'Nyní mimo provoz',
  liveRoute: 'Linka {route} · směr {headsign}',
  viewLive: 'Ukázat živě na mapě',
  firstSeen: 'První výskyt',
  lastSeen: 'Poslední výskyt',
  operator: 'Dopravce',
  vehicleModel: 'Typ vozu',
  identityQuality: 'Kvalita identity',
  registrationHistory: 'Historie evidenčních čísel',
  registrationChanged: 'Evidenční číslo se v historii změnilo.',
  registrationCurrent: 'dosud',
  registrationPeriod: '{from} – {to}',
  period: 'Období',
  periodToday: 'Dnes',
  period7d: '7 dní',
  period28d: '4 týdny',
  period90d: '3 měsíce',
  periodCustom: 'Vlastní',
  from: 'Od',
  to: 'Do',
  activeDays: 'Aktivní dny',
  trips: 'Spoje',
  tripCount: 'žádný spoj | {count} spoj | {count} spoje | {count} spojů',
  observedTime: 'Čas v provozu',
  estimatedDistance: 'Odhad vzdálenosti',
  observations: 'Pozorování',
  routeFrequency: 'Mapa četnosti pohybu',
  routeFrequencyDescription: 'Intenzita ukazuje agregované průjezdy po úsecích tras, ne počet GPS bodů.',
  metric: 'Metrika mapy',
  metricPassages: 'Průjezdy',
  metricDuration: 'Čas',
  metricDistance: 'Vzdálenost',
  metricActiveDays: 'Aktivní dny',
  legendLow: 'méně',
  legendHigh: 'častěji',
  segmentDetails: 'Detail úseku',
  passages: 'Počet průjezdů',
  routesOnSegment: 'Linky na úseku',
  heatmapEmpty: 'Pro toto období nelze mapu vytvořit. Chybí dostatek spárovaných tras.',
  heatmapError: 'Mapová agregace teď není dostupná.',
  mapError: 'Mapový podklad se nepodařilo načíst. Agregované statistiky zůstávají dostupné.',
  routeStats: 'Přehled linek',
  routeStatsDescription: 'Kliknutím na linku omezíte mapu i denní timeline.',
  route: 'Linka',
  days: 'Dnů',
  firstLast: 'První / poslední',
  filterRoute: 'Filtrovat linku {route}',
  routeFilterActive: 'Aktivní filtr: linka {route}',
  clearRouteFilter: 'Zrušit filtr linky',
  serviceDays: 'Provozní dny',
  serviceDaysDescription: 'Denní souhrny podle dopravního service date.',
  dayRange: '{first}–{last}',
  routeChanges: 'žádná změna linky | {count} změna linky | {count} změny linek | {count} změn linek',
  stopPassages: '{count} průjezdů zastávkou',
  depotJourney: 'Pravděpodobně {from} → {to}',
  depotUnknown: 'vozovna neurčena',
  dayNotFinalized: 'Den ještě není finalizovaný',
  lowDataQuality: 'nižší kvalita dat',
  dayDetail: 'Průběh provozního dne',
  timeline: 'Časová osa',
  timelineEmpty: 'Pro tento den nejsou dostupné veřejné provozní události.',
  tripAssignments: 'Zaznamenané spoje',
  tripFromTo: '{from} → {to}',
  incompleteTrip: 'neúplný záznam',
  estimated: 'odhad',
  confidence: 'Jistota: {confidence}',
  reason: 'Proč jde o odhad',
  reasonCode: 'Kód důvodu: {code}',
  dataQuality: 'Kvalita historie',
  mapMatched: '{value} % poloh bylo spárováno s trasou',
  highConfidenceTrips: '{value} % spojů má vysokou jistotu',
  longGaps: '{count} delších výpadků dat',
  lowConfidenceInferences: '{count} odhadů s nízkou jistotou',
  noQualityData: 'Souhrn kvality pro toto období není dostupný.',
  partialData: 'Historická data jsou dostupná jen pro část zvoleného období.',
  sectionUnavailable: 'Některé části historie se nepodařilo načíst. Dostupná data zůstávají zobrazená.',
  noHistory: 'Vozidlo zatím nemá historii ve zvoleném období.',
  notFound: 'Historickou identitu vozidla se nepodařilo najít.',
  loadError: 'Historii vozidla se teď nepodařilo načíst.',
  loadingIdentity: 'Načítám identitu vozidla…',
  loadingHistory: 'Načítám historické agregace…',
  loadingDay: 'Načítám detail provozního dne…',
  retry: 'Zkusit znovu',
  openHistory: 'Historie vozidla',
  openingHistory: 'Hledám historii…',
  historyUnavailable: 'Historická identita zatím není dostupná.',
  privacyNote: 'Historie popisuje provoz vozidla, nikoli řidiče nebo personál.',
  confidenceLevel: {
    high: 'vysoká',
    medium: 'střední',
    low: 'nízká',
    unknown: 'neurčená',
  },
  identity: {
    stableproviderid: 'stabilní ID poskytovatele',
    registrationnumberfallback: 'odvozeno z evidenčního čísla',
    compositeheuristic: 'složený odhad identity',
    unknown: 'nestabilní identita',
  },
  event: {
    firstseen: 'První záznam vozidla',
    lastseen: 'Poslední záznam vozidla',
    tripstarted: 'Zahájen spoj linky {route}',
    tripended: 'Ukončen spoj linky {route}',
    tripchanged: 'Navázán nový spoj linky {route}',
    assignmentstarted: 'Zahájen výkon na lince {route}',
    assignmentended: 'Ukončen výkon na lince {route}',
    routeassignmentstarted: 'Zahájen výkon na lince {route}',
    routeassignmentended: 'Ukončen výkon na lince {route}',
    tripassignmentstarted: 'Zahájen spoj linky {route}',
    tripassignmentended: 'Ukončen spoj linky {route}',
    routechanged: 'Přechod z linky {from} na linku {to}',
    stoparrival: 'Příjezd do zastávky {stop}',
    stopdeparture: 'Odjezd ze zastávky {stop}',
    shortobservationgap: 'Krátký výpadek pozorování',
    gapstarted: 'Začal delší výpadek pozorování',
    gapended: 'Pozorování bylo po delším výpadku obnoveno',
    longobservationgapstarted: 'Začal delší výpadek pozorování',
    longobservationgapended: 'Pozorování bylo po delším výpadku obnoveno',
    servicegapstarted: 'Začal výpadek pozorování',
    servicegapended: 'Pozorování bylo obnoveno',
    servicedaystarted: 'Zahájen provozní den',
    servicedayended: 'Ukončen provozní den',
    depotdepartureinferred: 'Pravděpodobný výjezd – {depot}',
    depotarrivalinferred: 'Pravděpodobné zatažení – {depot}',
    depotpullout: 'Pravděpodobný výjezd – {depot}',
    depotpullin: 'Pravděpodobné zatažení – {depot}',
    longobservationgap: 'Delší výpadek pozorování',
    dataqualitywarning: 'Upozornění na kvalitu dat',
    unknown: 'Provozní událost',
  },
  reasonCodes: {
    depot_proximity_and_movement: 'Poloha a následný pohyb odpovídají výjezdu nebo zatažení u vozovny.',
    first_positions_near_depot: 'První známé polohy byly poblíž vozovny a vůz následně zahájil spoj.',
    last_positions_near_depot: 'Poslední známé polohy směřovaly k vozovně před koncem provozu.',
    inferred_from_stop_progression: 'Čas byl odhadnut z postupu vozidla mezi zastávkami.',
    arrival_inferred_from_next_stop_transition: 'Příjezd byl odhadnut podle změny následující zastávky.',
    provider_gap: 'Zdrojová data měla v této části provozu výpadek.',
    stationary_at_service_start: 'Vozidlo bylo na začátku provozu opakovaně pozorováno bez pohybu poblíž vozovny.',
    stationary_at_service_end: 'Vozidlo bylo na konci provozu opakovaně pozorováno bez pohybu poblíž vozovny.',
    explicit_provider_depot: 'Zdroj dat výslovně uvedl tuto vozovnu.',
    departed_depot_toward_assignment: 'První bod byl v areálu, další body se vzdalovaly a navázal veřejný spoj.',
    approached_depot_after_assignment: 'Po konci výkonu se poslední body souvisle přibližovaly k vozovně.',
    proximity_only: 'K dispozici je pouze blízkost vozovny bez průkazné trajektorie.',
    no_directional_movement: 'Body nepotvrzují souvislý pohyb do areálu nebo z něj.',
    insufficient_consecutive_observations: 'Pro spolehlivější odhad nebylo dost souvislých pozorování.',
    vehicle_moving: 'Samotný pohyb poblíž vozovny bez návaznosti na výkon nestačí.',
    vehicle_in_service: 'Vozidlo bylo v daném okamžiku stále ve veřejném spoji.',
    ambiguous_nearby_depots: 'Poloha je podobně blízko více vozovnám.',
    returned_to_service: 'Vozidlo se po předběžném návratu znovu objevilo v provozu.',
    not_first_session: 'Nešlo o první session tohoto provozního dne.',
    outside_depot_radius: 'Poloha je mimo povolenou vzdálenost od vozovny.',
    too_far_from_service_boundary: 'Časová mezera k začátku nebo konci výkonu je příliš dlouhá.',
    no_compatible_depot: 'Pro tento typ vozidla nebyla nalezena odpovídající vozovna.',
    missing_position: 'Pro odhad chybí použitelná poloha.',
    unknown: 'Odhad vychází z dostupných provozních pozorování.',
  },
  warnings: {
    partial_data: 'Část období ještě není finalizovaná nebo má neúplná pozorování.',
    low_map_match_rate: 'Menší část poloh se podařila spolehlivě přiřadit k trase.',
    weak_identity: 'Dlouhodobá identita využívá fallback nebo heuristiku místo stabilního ID zdroje.',
    partial_period: 'Část období není pokryta historickými daty.',
    long_observation_gaps: 'V datech jsou delší mezery.',
    low_map_match_ratio: 'Menší část poloh se podařila přiřadit k trase.',
    unstable_identity: 'Identita vozidla není ve všech záznamech stabilní.',
    low_confidence_inferences: 'Některé provozní události mají nízkou jistotu.',
    long_gaps: 'V datech jsou delší mezery.',
    missing_trip_samples: 'U části pozorování chybí stabilní identifikace spoje.',
    no_data: 'Ve zvoleném období nejsou dostupná historická pozorování.',
    unknown: 'Historie obsahuje omezení kvality dat.',
  },
}

export const historyEn = {
  backToMap: 'Back to live map',
  historicalData: 'Historical vehicle data',
  vehicleWithoutRegistration: 'Provider vehicle',
  providerIdentity: 'Provider ID {id}',
  activeNow: 'Currently in service',
  inactiveNow: 'Currently out of service',
  liveRoute: 'Route {route} · towards {headsign}',
  viewLive: 'Show live on map',
  firstSeen: 'First seen',
  lastSeen: 'Last seen',
  operator: 'Operator',
  vehicleModel: 'Vehicle model',
  identityQuality: 'Identity quality',
  registrationHistory: 'Fleet number history',
  registrationChanged: 'The fleet number changed during the recorded history.',
  registrationCurrent: 'present',
  registrationPeriod: '{from} – {to}',
  period: 'Period',
  periodToday: 'Today',
  period7d: '7 days',
  period28d: '4 weeks',
  period90d: '3 months',
  periodCustom: 'Custom',
  from: 'From',
  to: 'To',
  activeDays: 'Active days',
  trips: 'Trips',
  tripCount: '{count} trip | {count} trips',
  observedTime: 'Time in service',
  estimatedDistance: 'Estimated distance',
  observations: 'Observations',
  routeFrequency: 'Route frequency map',
  routeFrequencyDescription: 'Intensity represents aggregated segment passages, not the number of GPS points.',
  metric: 'Map metric',
  metricPassages: 'Passages',
  metricDuration: 'Time',
  metricDistance: 'Distance',
  metricActiveDays: 'Active days',
  legendLow: 'less',
  legendHigh: 'more often',
  segmentDetails: 'Segment detail',
  passages: 'Passages',
  routesOnSegment: 'Routes on segment',
  heatmapEmpty: 'The map cannot be built for this period because matched trip data is missing.',
  heatmapError: 'The map aggregation is currently unavailable.',
  mapError: 'The map background could not be loaded. Aggregated statistics remain available.',
  routeStats: 'Route overview',
  routeStatsDescription: 'Select a route to filter both the map and daily timeline.',
  route: 'Route',
  days: 'Days',
  firstLast: 'First / last',
  filterRoute: 'Filter route {route}',
  routeFilterActive: 'Active filter: route {route}',
  clearRouteFilter: 'Clear route filter',
  serviceDays: 'Service days',
  serviceDaysDescription: 'Daily summaries use the transit service date.',
  dayRange: '{first}–{last}',
  routeChanges: '{count} route change | {count} route changes',
  stopPassages: '{count} stop passages',
  depotJourney: 'Likely {from} → {to}',
  depotUnknown: 'depot not inferred',
  dayNotFinalized: 'Day has not been finalized yet',
  lowDataQuality: 'lower data quality',
  dayDetail: 'Service day detail',
  timeline: 'Timeline',
  timelineEmpty: 'No public service events are available for this day.',
  tripAssignments: 'Observed trips',
  tripFromTo: '{from} → {to}',
  incompleteTrip: 'incomplete record',
  estimated: 'estimate',
  confidence: 'Confidence: {confidence}',
  reason: 'Why this is an estimate',
  reasonCode: 'Reason code: {code}',
  dataQuality: 'History quality',
  mapMatched: '{value}% of positions were matched to a route',
  highConfidenceTrips: '{value}% of trips have high confidence',
  longGaps: '{count} longer data gaps',
  lowConfidenceInferences: '{count} low-confidence estimates',
  noQualityData: 'No data-quality summary is available for this period.',
  partialData: 'Historical data is available for only part of the selected period.',
  sectionUnavailable: 'Some history sections could not be loaded. Available data remains visible.',
  noHistory: 'This vehicle has no history in the selected period yet.',
  notFound: 'The historical vehicle identity could not be found.',
  loadError: 'Vehicle history could not be loaded right now.',
  loadingIdentity: 'Loading vehicle identity…',
  loadingHistory: 'Loading historical aggregates…',
  loadingDay: 'Loading service-day detail…',
  retry: 'Try again',
  openHistory: 'Vehicle history',
  openingHistory: 'Finding history…',
  historyUnavailable: 'A historical identity is not available yet.',
  privacyNote: 'History describes vehicle operation, not drivers or personnel.',
  confidenceLevel: { high: 'high', medium: 'medium', low: 'low', unknown: 'unknown' },
  identity: {
    stableproviderid: 'stable provider ID',
    registrationnumberfallback: 'derived from fleet number',
    compositeheuristic: 'composite identity estimate',
    unknown: 'unstable identity',
  },
  event: {
    firstseen: 'First vehicle observation',
    lastseen: 'Last vehicle observation',
    tripstarted: 'Started a trip on route {route}',
    tripended: 'Ended a trip on route {route}',
    tripchanged: 'Started another trip on route {route}',
    assignmentstarted: 'Started service on route {route}',
    assignmentended: 'Ended service on route {route}',
    routeassignmentstarted: 'Started service on route {route}',
    routeassignmentended: 'Ended service on route {route}',
    tripassignmentstarted: 'Started a trip on route {route}',
    tripassignmentended: 'Ended a trip on route {route}',
    routechanged: 'Changed from route {from} to route {to}',
    stoparrival: 'Arrived at {stop}',
    stopdeparture: 'Departed from {stop}',
    shortobservationgap: 'Short observation gap',
    gapstarted: 'Longer observation gap started',
    gapended: 'Observations resumed after a longer gap',
    longobservationgapstarted: 'Longer observation gap started',
    longobservationgapended: 'Observations resumed after a longer gap',
    servicegapstarted: 'Observation gap started',
    servicegapended: 'Observations resumed',
    servicedaystarted: 'Service day started',
    servicedayended: 'Service day ended',
    depotdepartureinferred: 'Probable departure from {depot}',
    depotarrivalinferred: 'Probable return to {depot}',
    depotpullout: 'Probable departure from {depot}',
    depotpullin: 'Probable return to {depot}',
    longobservationgap: 'Longer observation gap',
    dataqualitywarning: 'Data-quality warning',
    unknown: 'Service event',
  },
  reasonCodes: {
    depot_proximity_and_movement: 'Position and subsequent movement match a depot departure or return.',
    first_positions_near_depot: 'The first known positions were near a depot before the vehicle started a trip.',
    last_positions_near_depot: 'The last known positions approached a depot before service ended.',
    inferred_from_stop_progression: 'The time was estimated from the vehicle’s progress between stops.',
    arrival_inferred_from_next_stop_transition: 'Arrival was estimated from a change of the next stop.',
    provider_gap: 'Source data had a gap during this part of service.',
    stationary_at_service_start: 'The vehicle was repeatedly observed stationary near a depot before service began.',
    stationary_at_service_end: 'The vehicle was repeatedly observed stationary near a depot when service ended.',
    explicit_provider_depot: 'The data source explicitly identified this depot.',
    departed_depot_toward_assignment: 'The first point was inside the area, movement continued outward, and a public trip followed.',
    approached_depot_after_assignment: 'After the assignment ended, the final observations consistently approached the depot.',
    proximity_only: 'Only proximity is available; there is no conclusive movement trajectory.',
    no_directional_movement: 'The observations do not confirm continuous movement into or out of the depot.',
    insufficient_consecutive_observations: 'There were too few consecutive observations for a stronger estimate.',
    vehicle_moving: 'Movement near a depot without an assignment transition is insufficient.',
    vehicle_in_service: 'The vehicle was still operating a public trip at this point.',
    ambiguous_nearby_depots: 'The position is similarly close to more than one depot.',
    returned_to_service: 'The vehicle returned to service after the provisional depot visit.',
    not_first_session: 'This was not the first session of the service day.',
    outside_depot_radius: 'The position is outside the accepted depot distance.',
    too_far_from_service_boundary: 'The time gap to the assignment boundary is too large.',
    no_compatible_depot: 'No compatible depot was found for this vehicle mode.',
    missing_position: 'No usable position is available for the estimate.',
    unknown: 'The estimate is based on the available service observations.',
  },
  warnings: {
    partial_data: 'Part of the period is not finalized yet or has incomplete observations.',
    low_map_match_rate: 'A smaller share of positions could be matched to a route reliably.',
    weak_identity: 'The long-term identity uses a fallback or heuristic instead of a stable source ID.',
    partial_period: 'Part of the period is not covered by historical data.',
    long_observation_gaps: 'There are longer gaps in the observations.',
    low_map_match_ratio: 'A smaller share of positions could be matched to a route.',
    unstable_identity: 'The vehicle identity is not stable across all records.',
    low_confidence_inferences: 'Some service events have low confidence.',
    long_gaps: 'There are longer gaps in the observations.',
    missing_trip_samples: 'Some observations do not have a stable trip identifier.',
    no_data: 'No historical observations are available for the selected period.',
    unknown: 'The history has data-quality limitations.',
  },
}
